import { InputText } from "primereact/inputtext";
import './MarkerDetailsList.scss';
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';

const MarkerDetailsList = ({ details, updateDetails, setStopMarkers }) => {

    const timeStringToDate = (timeString) => {
        const [hours, minutes] = timeString.split(":").map(Number);
        const date = new Date();
        date.setHours(hours, minutes);
        return date;
    };

    const dateToTimeString = (date) => {
        return date.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', hour12: false });
    };

    const handleNameChange = (index, newName) => {
        updateDetails(prevDetails =>
            prevDetails.map((detail, i) =>
                i === index ? { ...detail, name: newName } : detail
            )
        );
    };

    const handleReferenceChange = (index, newReference) => {
        updateDetails(prevDetails =>
            prevDetails.map((detail, i) =>
                i === index ? { ...detail, reference: newReference || '' } : detail
            )
        );
    };

    const handleScheduleChange = (index, newDate) => {
        const formattedTime = newDate ? dateToTimeString(newDate) : "";
        updateDetails(prevDetails => {
            const previousTime = prevDetails[index].schedule;
            const diffMinutes = calculateTimeDifference(previousTime, formattedTime);
            return prevDetails.map((detail, i) => {
                if (i === index) {
                    return { ...detail, schedule: formattedTime };
                } else if (i > index && diffMinutes !== 0) {
                    const adjustedTime = addMinutesToTime(detail.schedule, diffMinutes);
                    return { ...detail, schedule: adjustedTime };
                }
                return detail;
            });
        });
    };

    const handleRemoveStop = (index) => {
        confirmDialog({
            message: `¿Seguro que quieres borrar "${details[index]?.name || `Parada ${index + 1}`}"?`,
            header: 'Borrar parada',
            icon: 'pi pi-trash',
            acceptLabel: 'Sí, borrar',
            rejectLabel: 'No, dejar',
            acceptClassName: 'p-button-danger',
            accept: () => {
                updateDetails(prevDetails => prevDetails.filter((_, i) => i !== index));
                setStopMarkers(prevMarkers => prevMarkers.filter((_, i) => i !== index));
            }
        });
    };

    const calculateTimeDifference = (oldTime, newTime) => {
        if (!oldTime || !newTime) return 0;
        const [oldHours, oldMinutes] = oldTime.split(':').map(Number);
        const [newHours, newMinutes] = newTime.split(':').map(Number);
        return (newHours * 60 + newMinutes) - (oldHours * 60 + oldMinutes);
    };

    const addMinutesToTime = (time, minutesToAdd) => {
        if (!time) return time;
        const [hours, minutes] = time.split(':').map(Number);
        let totalMinutes = hours * 60 + minutes + minutesToAdd;
        totalMinutes = ((totalMinutes % 1440) + 1440) % 1440;
        const newHours = Math.floor(totalMinutes / 60);
        const newMinutes = totalMinutes % 60;
        return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
    };

    if (details.length === 0) {
        return (
            <div className="schedule">
                <div className="empty-stops">
                    <i className="pi pi-map-marker" />
                    <p>No hay paradas todavía</p>
                    <span>Regresa al paso anterior para agregar paradas en el mapa</span>
                </div>
            </div>
        );
    }

    return (
        <div className="schedule">
            <ConfirmDialog />
            {details.map((detail, index) => (
                <div key={index} className="stop-card">
                    {/* Header de la tarjeta */}
                    <div className="stop-card-header">
                        <div className="stop-number-badge">{index + 1}</div>
                        <div className="stop-card-title">
                            Parada {index + 1}
                            {index === 0 && <span className="stop-tag inicio">Inicio</span>}
                            {index === details.length - 1 && details.length > 1 && <span className="stop-tag fin">Fin</span>}
                        </div>
                        <Button
                            icon="pi pi-trash"
                            className="p-button-danger p-button-text p-button-rounded stop-delete-btn"
                            onClick={() => handleRemoveStop(index)}
                            tooltip="Borrar esta parada"
                            tooltipOptions={{ position: 'left' }}
                        />
                    </div>

                    {/* Cuerpo */}
                    <div className="stop-card-body">
                        <div className="stop-field">
                            <label>
                                <i className="pi pi-tag" />
                                Nombre
                            </label>
                            <InputText
                                className="stop-input"
                                value={detail.name}
                                placeholder="Ej: Esquina de la tienda azul"
                                onChange={(e) => handleNameChange(index, e.target.value)}
                            />
                        </div>

                        <div className="stop-fields-row">
                            <div className="stop-field">
                                <label>
                                    <i className="pi pi-clock" />
                                    Horario
                                </label>
                                <Calendar
                                    value={detail.schedule ? timeStringToDate(detail.schedule) : null}
                                    onChange={(e) => handleScheduleChange(index, e.value)}
                                    timeOnly
                                    selectionMode="single"
                                    placeholder="--:--"
                                    className="stop-calendar"
                                />
                            </div>

                            <div className="stop-field">
                                <label>
                                    <i className="pi pi-compass" />
                                    Referencia
                                </label>
                                <InputText
                                    className="stop-input"
                                    value={detail.reference}
                                    placeholder="Ej: Frente al Oxxo"
                                    onChange={(e) => handleReferenceChange(index, e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default MarkerDetailsList;
